@if (fetchingKpis > 0) {
  <div class="loading__message d-flex align-items-center">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="loading__message-text ml-3">Loading real-time data, please wait…</span>
  </div>
}
<div class="dashboard__container">
  <div class="dashboard__container_section">
    <app-dashboard-priorities
      [dashboard]="dashboardType"
      [boards]="boards"
      (boardsLoaded)="boards = $event"
      (isFetchingKpis)="isFetchingKpis($event)"
    ></app-dashboard-priorities>
    <app-dashboard-date-ranges
      [dashboard]="dashboardType"
      [boards]="boards"
      (isFetchingKpis)="isFetchingKpis($event)"
    ></app-dashboard-date-ranges>
  </div>
  <div class="dashboard__container_section">
    <app-dashboard-thirty-days-chart
      [dashboard]="dashboardType"
      [boards]="boards"
      (isFetchingKpis)="isFetchingKpis($event)"
    ></app-dashboard-thirty-days-chart>
    <app-dashboard-summaries
      [dashboard]="dashboardType"
      [boards]="boards"
      (isFetchingKpis)="isFetchingKpis($event)"
    ></app-dashboard-summaries>
  </div>
</div>
